if (!customElements.get('email-signup')) {
  class EmailSignup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.emailInput = this.querySelector('input[type="email"]');
      this.firstNameInput = this.querySelector('input[name="first_name"]');
      this.lastNameInput = this.querySelector('input[name="last_name"]');
      this.successMsg = this.querySelector('.email-signup__success-message');
      this.errorMsg = this.querySelector('.email-signup__error-message');

      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    async handleSubmit(event) {
      event.preventDefault();

      const email = this.emailInput.value;
      const { publicKey, listId } = this.dataset;

      if (!email || !publicKey || !listId) return;

      this.form.setAttribute('aria-busy', 'true');

      try {
        const res = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${publicKey}`,
          {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              'revision': '2023-12-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email }
                    }
                  }
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: listId
                    }
                  }
                }
              }
            })
          }
        );

        if (!res.ok) {
          this.errorMsg.classList.add('active');
          this.successMsg.classList.remove('active');

          const body = await res.json().catch(() => ({}));
          throw new Error(JSON.stringify(body));
        }

        this.form.hidden = true;
        this.successMsg.classList.add('active');
        this.errorMsg.classList.remove('active');
      } catch (err) {
        console.error('Klaviyo subscription error:', err);
        this.form.removeAttribute('aria-busy');
        this.errorMsg.classList.add('active');
        this.successMsg.classList.remove('active');
      }
    }
  }

  customElements.define('email-signup', EmailSignup);
}
